import { render, staticRenderFns } from "./summary_table.vue?vue&type=template&id=68aea997&scoped=true&"
import script from "./summary_table.vue?vue&type=script&lang=js&"
export * from "./summary_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aea997",
  null
  
)

export default component.exports